export default __webpack_public_path__ + "static/monetisation@2x-b0cd342b3f804785ae70bdf013e8ee98.png";